import React, { useEffect, useState } from "react";
import { Dialog } from "@headlessui/react";
import {
  AdjustmentsVerticalIcon,
  ArrowTrendingUpIcon,
  Bars3Icon,
  ChartBarIcon,
  DocumentIcon,
  PencilSquareIcon,
  RectangleGroupIcon,
  UserGroupIcon,
  UserIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../../../App.css";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import { ChatBubbleLeftEllipsisIcon } from "@heroicons/react/24/outline";
import { use } from "react";
import { Tooltip } from "react-tooltip";
import { CalendarIcon, ChartBar, ClockIcon, Pen } from "lucide-react";
import {
  DocumentArrowUpIcon,
  DocumentTextIcon,
} from "@heroicons/react/20/solid";

function LeadDiscusstion({ id_crypt, leadId }) {

  const adminId = localStorage.getItem("role_id");

  
  const [discussionIdCrypt, setDiscussionIdCrypt] = useState(id_crypt);
  const [leadDiscusstion, setLeadDiscusstion] = useState(false);
  const [userId, setUserId] = useState([]);
  const [discussion, setDiscussion] = useState({
    comments: "",
    lead_task_id: "",
    task_discussion_status_id: "",
    task_type: "",
    discussion_employee_id: "",
    start_time: "",
    end_time: "",
  });
  const [discussionData, setDiscussionData] = useState([]);
  const [idCryptForDiscussion, setIdCryptForDiscussion] = useState("");
  const [viewForAllTask, setViewForAllTask] = useState([]);
  const [enableButton, setEnableButton] = useState(false);

  
  const [chooseDiscussionOrDetails, setChooseDiscussionOrDetails] =
    useState("discussion");
    
    

  const toolbarOptions = [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline", "strike"],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ["blockquote", "code-block"],
    ["link", "image"],
    ["clean"],
  ];
  const [saveBtn, setSaveBtn] = useState("save");
  const [discussionStatus, setDiscussionStatus] = useState([]);

  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const fetchDiscussionForLeads = async () => {
    try {
      const response = await axios.get(
        `public/api/admin/taskdiscussion/edit/${idCryptForDiscussion}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
   

      setDiscussionData(response.data.leadtaskdiscussion);
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to fetch discussion"
      );
    }
  };

  // useEffect(() => {
  //   fetchDiscussionForLeads();
  // }, [idCryptForDiscussion]);

  const fetchDiscussion = async () => {
    try {
      const responseForDiscussionStatus = await axios.get(
        `public/api/admin/taskdiscussionstatus`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setDiscussionStatus(
        responseForDiscussionStatus.data.TaskDiscussionStatus
      );

    } catch (error) {
      console.error("Error fetching discussion:", error);
    }
  };

  useEffect(() => {
    fetchDiscussion();
  }, []);

  // const handleDiscussionForLead = async (id_crypt) => {
  //   const currentLoginId = localStorage.getItem("user_id");
  //   setIdCryptForDiscussion(id_crypt);
  //   const currentLoginIdNum = parseInt(currentLoginId, 10);
  //   setLeadDiscusstion(true);
  //   try {
  //     const responseForTaskview = await axios.get(
  //       public/api/admin/tasks/edit/${id_crypt},
  //       {
  //         headers: {
  //           Authorization: Bearer ${localStorage.getItem("token")},
  //         },
  //       }
  //     );
  //     setViewForAllTask(responseForTaskview.data.task);

  //     const enableSendButton =
  //       currentLoginIdNum === 1
  //         ? false
  //         : responseForTaskview.data.task.task_member.some(
  //             (item) => parseInt(item.user_id, 10) === currentLoginIdNum
  //           );

  //     const currentEmployee = responseForTaskview.data.task.task_member.find(
  //       (item) => parseInt(item.user_id, 10) === currentLoginIdNum
  //     );

  //     setSaveBtn(enableSendButton ? "save" : "update");
  //     setEnableButton(enableSendButton);

  //     setUserId(
  //       responseForTaskview.data.task.task_member.map((item) => item.user_id)
  //     );

  //     if (responseForTaskview.data.task.task_type === "1") {
  //       setDiscussion({
  //         task_type: "1",
  //         lead_task_id: responseForTaskview.data.task.id,
  //         discussion_employee_id: currentEmployee?.id, 
  //       });
  //     } else if (responseForTaskview.data.task.task_type === "2") {
  //       setDiscussion({
  //         task_type: "2",
  //         lead_task_id: responseForTaskview.data.task.id,
  //         discussion_employee_id: currentEmployee?.id,
  //       });
  //     }

  //     const response = await axios.get(
  //       public/api/admin/taskdiscussion/edit/${id_crypt},
  //       {
  //         headers: {
  //           Authorization: Bearer ${localStorage.getItem("token")},
  //         },
  //       }
  //     );
  //     setDiscussionData(response.data.leadtaskdiscussion);
  //   } catch (error) {}
  // };


  const handleDiscussionForLead = async (id_crypt) => {
    const currentLoginId = localStorage.getItem("user_id");
    setIdCryptForDiscussion(id_crypt);
    const currentLoginIdNum = parseInt(currentLoginId, 10);
    setLeadDiscusstion(true);

    try {
        // Fetch task details
        const responseForTaskview = await axios.get(
            `public/api/admin/tasks/edit/${id_crypt}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            }
        );
        console.log(responseForTaskview.data.task,"hii");
        
        setViewForAllTask(responseForTaskview.data);

        // const enableSendButton =
        //     currentLoginIdNum === 1
        //         ? true
        //         : responseForTaskview.data.task.task_member.some(
        //               (item) => parseInt(item.user_id, 10) === currentLoginIdNum
        //           );

        const enableSendButton =
    parseInt(adminId, 10) === 1 || // If the logged-in user is an admin, enable the button
    responseForTaskview.data.task.task_member.some(
        (item) => parseInt(item.user_id, 10) === currentLoginIdNum
    );

        const currentEmployee = responseForTaskview.data.task.task_member.find(
            (item) => parseInt(item.user_id, 10) === currentLoginIdNum
        );

        setSaveBtn(enableSendButton ? "save" : "update");
        setEnableButton(enableSendButton);

        setUserId(
            responseForTaskview.data.task.task_member.map((item) => item.user_id)
        );

    

        // Ensure lead_task_id is correctly set
        setDiscussion({
            task_type: responseForTaskview.data.task.task_type,
            lead_task_id: responseForTaskview.data.task.id,
            discussion_employee_id: currentEmployee?.id || null,
            comments: "",
            start_time: "",
            end_time: "",
        });

        // Fetch discussions
        const response = await axios.get(
            `public/api/admin/taskdiscussion/edit/${id_crypt}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            }
        );

        setDiscussionData(response.data.leadtaskdiscussion);
    } catch (error) {
        console.error("Error fetching task or discussion:", error);
    }
};

  const handleChangeForTaskComments = (e) => {
    const { name, value } = e.target;

    const formattedValue = value.length === 5 ? `${value}:00` : value;

    setDiscussion((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));
  };

  const fetchDiscussionAfterSubmit = async () => {
    if (!idCryptForDiscussion) {
        console.error("idCryptForDiscussion is undefined or empty");
        return;
    }

    try {
        const response = await axios.get(
            `public/api/admin/taskdiscussion/edit/${idCryptForDiscussion}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            }
        );


        setDiscussionData(response.data.leadtaskdiscussion);
    } catch (error) {
        console.error("Error fetching discussion:", error);
    }
};

  // const handleSubmitForTaskDiscussion = async (e) => {
  //   e.preventDefault();

  //   try {
  //     const payload = {
  //       ...discussion,
  //       start_time: discussion.start_time || null, 
  //       end_time: discussion.end_time || null,
  //     };
  //     const response = await axios.post(
  //       public/api/admin/taskdiscussion/store,
  //       payload,
  //       {
  //         headers: { Authorization: Bearer ${localStorage.getItem("token")} },
  //       }
  //     );

  //     // if (response.status === 200) {
  //       await fetchDiscussionAfterSubmit();
  //       toast.success(response.data.message);
  //       setLeadDiscusstion(true);
        
  //       setDiscussion({
  //         comments: "",
  //         start_time: "",
  //         end_time: "",
  //       });
  //     // }
  //   } catch (error) {
  //     console.error("Error submitting discussion:", error);
  //   }
  // };

  const handleSubmitForTaskDiscussion = async (e) => {
    e.preventDefault();

    try {
        const payload = {
            ...discussion,
            start_time: discussion.start_time || null,
            end_time: discussion.end_time || null,
        };



        const response = await axios.post(
            `public/api/admin/taskdiscussion/store`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            }
        );



        await fetchDiscussionAfterSubmit();
        toast.success(response.data.message);
        setLeadDiscusstion(true);

        // Preserve lead_task_id after clearing other fields
        setDiscussion((prev) => ({
            ...prev,
            comments: "",
            start_time: "",
            end_time: "",
        }));
    } catch (error) {
        console.error("Error submitting discussion:", error);
    }
};

  const formatTime = (time) => {
    if (!time) return "Select Time";
    let [hours, minutes] = time.split(":");
    let period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 24-hour to 12-hour format
    return `${hours}:${minutes} ${period}`;
  };

  return (
    <>
      <button
        className="my-anchor-discussion relative group cursor-pointer bg-yellow-400 rounded-md p-1"
        onClick={() => handleDiscussionForLead(id_crypt)}
      >
        <ChatBubbleLeftEllipsisIcon className="h-5 w-5 text-white" />
        <Tooltip
          anchorSelect=".my-anchor-discussion"
          place="top"
          className="text-xs p-0"
          style={{ fontSize: "12px", padding: "0.3rem" }}
        >
          Discussion
        </Tooltip>
      </button>

      {leadDiscusstion && (
        <Dialog
          open={leadDiscusstion}
          onClose={() => {}}
          className="relative z-10"
        >
          <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto ">
                <div
                  className="flex justify-between p-4 sticky top-0 z-50 text-white"
                  style={{ backgroundColor: "#6366f1" }}
                >
                  <h1 className="mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium uppercase">
                    Lead Management Task Discussion
                  </h1>
                  <XMarkIcon
                    onClick={() => setLeadDiscusstion(false)}
                    className="h-6 w-6 cursor-pointer"
                  />
                </div>

                <div className="w-full col-span-1 sm:col-span-1">
                  {/* overflow-y-scroll custom-scrollbar */}
                  <div className="mt-4 bg-white rounded-lg p-2 h-100">
                    <div class="grid grid-cols-1 flex sm:grid-cols-3  p-4 bg-white h-full">
                      <div className="col-span-2 gap-4 p-1 ">
                        <div className="max-h-[80vh] h-100 overflow-y-auto custom-scrollbar">
                          <div className=" pb-3">
                            <div className="flex items-center flex-wrap gap-4 ">
                              <h4 className="font-semibold text-gray-800 text-sm sm:text-md">
                                Discussion for:{" "}
                              </h4>
                              <span
                                className={`px-3 rounded py-1 font-medium ${
                                  viewForAllTask?.task?.task_name
                                    ? "bg-blue-100 text-blue-800"
                                    : "bg-gray-100 text-gray-600"
                                }`}
                              >
                                {viewForAllTask?.task?.task_name ?? "N/A"}
                              </span>
                            </div>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-1 gap-6 p-4">
                            <div className="">
                              <span className="flex items-center gap-2 border-b mb-4 py-1">
                                <DocumentTextIcon className="h-5 w-5 text-green-600" />
                                <h4 className="text-green-800 text-md font-semibold">
                                  Description
                                </h4>
                              </span>
                              <p className="text-justify">
                                {viewForAllTask?.task?.task_description
                                  ?.replace(/<[^>]*>/g, "")
                                  .trim() ?? "N/A"}
                              </p>

                              {/* <p className="text-xs font-semibold  sm:text-sm text-gray-800">
                                          {comment.discussion.comments
                                            .replace(/<[^>]*>/g, "")
                                            .trim()}
                                        </p> */}
                            </div>
                          </div>

                          <div className="p-6 bg-white rounded-lg shadow-md">
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                              {/* TASK DISCUSSION */}
                              <div className="col-span-1 sm:col-span-2">
                                <label className="block text-sm font-medium text-gray-900 mb-2">
                                  TASK DISCUSSION
                                </label>
                                <ReactQuill
                                  theme="snow"
                                  value={discussion.comments}
                                  onChange={(content) =>
                                    setDiscussion((prev) => ({
                                      ...prev,
                                      comments: content,
                                    }))
                                  }
                                  modules={{ toolbar: toolbarOptions }}
                                  className="custom-editor h-[150px] sm:h-[150px] p-2"
                                  style={{ zIndex: 50 }}
                                />
                              </div>

                              {/* TIME SELECTION */}
                              <div className="col-span-1 mt-40 sm:mt-0 space-y-4">
                                <div>
                                  <label className="text-sm font-semibold text-gray-700">
                                    Start Time
                                  </label>
                                  <input
                                    name="start_time"
                                    type="time"
                                    value={discussion?.start_time}
                                    onChange={handleChangeForTaskComments}
                                    className="w-full h-10 mt-2 p-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                                  />
                                  {/* <span className="text-gray-600 text-sm">⏰ {formatTime(startTime)}</span> */}
                                </div>

                                <div>
                                  <label className="text-sm font-semibold text-gray-700">
                                    End Time
                                  </label>
                                  <input
                                    name="end_time"
                                    type="time"
                                    value={discussion?.end_time}
                                    onChange={handleChangeForTaskComments}
                                    className="w-full h-10 mt-2 p-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                                  />
                                  {/* <span className="text-gray-600 text-sm">⏰ {formatTime(endTime)}</span> */}
                                </div>

                                {/* STATUS SELECTION */}
                                <div>
                                  <label className="block text-sm font-medium text-gray-900 mb-2">
                                    SELECT STATUS
                                  </label>
                                  <Select
                                    name="task_discussion_status_id"
                                    options={discussionStatus?.map(
                                      (status) => ({
                                        value: status.id,
                                        label: status.name,
                                      })
                                    )}
                                    value={
                                      discussionStatus
                                        ?.filter(
                                          (status) =>
                                            status.id ===
                                            discussion?.task_discussion_status_id
                                        )
                                        ?.map((status) => ({
                                          value: status.id,
                                          label: status.name,
                                        })) || null
                                    }
                                    onChange={(selectedOption) =>
                                      handleChangeForTaskComments({
                                        target: {
                                          name: "task_discussion_status_id",
                                          value: selectedOption?.value,
                                        },
                                      })
                                    }
                                    className="w-full"
                                    classNamePrefix="select"
                                    placeholder="Select Status"
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Submit Button */}
                            {saveBtn === "save" && enableButton && (
                              <div className="flex justify-end mt-6">
                                <button
                                  onClick={handleSubmitForTaskDiscussion}
                                  className="py-2 px-4 bg-indigo-600 text-white border-transparent shadow-sm text-sm font-medium rounded-md hover:bg-indigo-700 transition-all"
                                >
                                  Send Discussion
                                </button>
                              </div>
                            )}
                          </div>
                          {/* <div className="min-h-20 mt-4 max-h-80 overflow-y-auto p-1"> */}
                          <div className="min-h-20 mt-4  p-1">
                            <h4 className=" text-md font-semibold">
                              Discussions
                            </h4>
                            <div className="min-h-[200px] ">
                              {" "}
                              {discussionData?.length > 0 ? (
                                discussionData
                                  .slice() // Create a shallow copy to avoid mutating the original data
                                  .sort(
                                    (a, b) =>
                                      new Date(b.discussion?.created_at) -
                                      new Date(a.discussion?.created_at)
                                  ) // Sort by date DESC
                                  .map((comment, index) => (
                                    <div key={index} className="p-1">
                                      <div className="flex flex-col  sm:flex-row justify-between items-start sm:items-center">
                                        <div className="flex-auto w-full rounded-md p-3 ring-1 ring-gray-200 ring-inset">
                                          <div className="flex justify-between gap-x-4">
                                            <div className="py-0.5 text-xs/5 text-gray-500">
                                              <span className="font-semibold flex items-center gap-x-2 text-gray-900 py-1 rounded-lg  hover:bg-gray-200 transition">
                                                <UserIcon className="h-5 w-5 text-blue-600 bg-white p-1 rounded-full shadow-md border border-gray-300" />
                                                {comment?.employee?.name}
                                              </span>
                                            </div>
                                            <time
                                              dateTime={
                                                comment.discussion?.created_at
                                              }
                                              className="flex-none py-0.5 font-bold text-xs/5 text-gray-500"
                                            >
                                              {comment.discussionstatus?.name}
                                            </time>
                                          </div>
                                          <p className="text-sm/6 text-justify text-gray-500">
                                            {comment.discussion.comments
                                              .replace(/<[^>]*>/g, "")
                                              .trim()}
                                          </p>
                                          {comment.discussion?.created_at && (
                                            <>
                                              <p className="mt-2 text-xs text-gray-400 text-right">
                                                Posted :{" "}
                                                {new Date(
                                                  comment.discussion.created_at
                                                ).toLocaleDateString("en-GB")}
                                              </p>
                                              <p className="mt-2 text-xs text-gray-400 text-right">
                                                Time :{" "}
                                                {new Date(
                                                  comment.discussion.created_at
                                                ).toLocaleTimeString([], {
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                })}
                                              </p>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ))
                              ) : (
                                <p className="text-center my-auto text-gray-500 text-sm">
                                  No comments available.
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-span-1">
                        <div className="grid grid-cols-1 gap-4 p-4  bg-white rounded-lg shadow-lg">
                          {[
                            {
                              label: "Task Name",
                              value: viewForAllTask?.task?.task_name ?? "N/A",
                              icon: "📋",
                            },
                            {
                              label: "Employees",
                              value:
                                viewForAllTask?.task?.task_member?.length > 0
                                  ? viewForAllTask.task?.task_member
                                      .map((emp) => emp.name)
                                      .join(", ")
                                  : "N/A",
                              icon: "👥",
                            },
                            {
                              label: "Start Date",
                              value: viewForAllTask?.task?.start_date
                                ? viewForAllTask?.task?.start_date
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                : "N/A",
                              icon: "📅",
                            },
                            {
                              label: "End Date",
                              value: viewForAllTask?.task?.end_date
                                ? viewForAllTask?.task?.end_date
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                : "N/A",
                              icon: "🛑",
                            },
                            {
                              label: "Created @",
                              value: `${
                                viewForAllTask?.task?.created_at
                                  ?.split("T")[0]
                                  .split("-")
                                  .reverse()
                                  .join("-") ?? "N/A"
                              } ${
                                viewForAllTask?.task?.created_at
                                  ? new Date(
                                      viewForAllTask?.task?.created_at
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    })
                                  : "N/A"
                              }`,
                              icon: "🕒",
                            },
                            {
                              label: "Priority",
                              value:
                                viewForAllTask?.task?.priority_name?.name ?? "N/A",
                              icon: "⚠️",
                            },
                            {
                              label: "Lead",
                              value: viewForAllTask?.task?.lead_name?.name ?? "N/A",
                              icon: "🚀",
                            },
                            {
                              label: "Task Status",
                              value:
                                viewForAllTask?.task?.task_status_name?.name ?? "N/A",
                              icon: "✅",
                            },
                            {
                              label: "Task Type",
                              value:
                                viewForAllTask?.task?.task_type === "1"
                                  ? "General"
                                  : viewForAllTask?.task?.task_type === "2"
                                  ? "Lead"
                                  : "N/A",
                              icon: "📄",
                            },
                            {
                              label: "Updated @",
                              value: viewForAllTask?.task?.updated_at
                                ? `${new Date(viewForAllTask.task?.updated_at).getDate()
                                    .toString()
                                    .padStart(2, "0")}-${(new Date(viewForAllTask.task?.updated_at).getMonth() + 1)
                                    .toString()
                                    .padStart(2, "0")}-${new Date(viewForAllTask.task?.updated_at).getFullYear()}  ${new Date(viewForAllTask.task?.updated_at).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}`
                                : "N/A",
                              icon: "🕓",
                            }
                            ,
                            {
                              label: "Updated By",
                              value: viewForAllTask?.task?.updated_by?.name ?? "N/A",
                              icon: "✍️",
                            },
                          ].map((item, index) => (
                            <div
                              key={index}
                              className="flex items-center justify-between p-3 border rounded-lg bg-gray-100 hover:bg-gray-200 transition-all"
                            >
                              <div className="flex items-center gap-2">
                                <span className="text-lg">{item?.icon}</span>
                                <h3 className="text-sm font-medium text-gray-900">
                                  {item?.label}
                                </h3>
                              </div>
                              <p className="text-sm text-gray-700 truncate">
                                {item?.value}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
}

export default LeadDiscusstion;